module.exports = __webpack_public_path__ + "img/rockestate_logo_aligned.647e2c55.svg";